/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BuildsRouteImport } from './routes/builds'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DrillsRouteImport } from './routes/drills'
import { Route as FreshMatchesRouteImport } from './routes/fresh-matches'
import { Route as FriendsRouteImport } from './routes/friends'
import { Route as HighlightsRouteImport } from './routes/highlights'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as StyleRouteImport } from './routes/style'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as MatchesMatchIdRouteImport } from './routes/matches/$matchId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BuildsRoute = BuildsRouteImport.update({
  id: '/builds',
  path: '/builds',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DrillsRoute = DrillsRouteImport.update({
  id: '/drills',
  path: '/drills',
  getParentRoute: () => rootRouteImport,
} as any)
const FreshMatchesRoute = FreshMatchesRouteImport.update({
  id: '/fresh-matches',
  path: '/fresh-matches',
  getParentRoute: () => rootRouteImport,
} as any)
const FriendsRoute = FriendsRouteImport.update({
  id: '/friends',
  path: '/friends',
  getParentRoute: () => rootRouteImport,
} as any)
const HighlightsRoute = HighlightsRouteImport.update({
  id: '/highlights',
  path: '/highlights',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const StyleRoute = StyleRouteImport.update({
  id: '/style',
  path: '/style',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const MatchesMatchIdRoute = MatchesMatchIdRouteImport.update({
  id: '/matches/$matchId',
  path: '/matches/$matchId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/builds': typeof BuildsRoute
  '/dashboard': typeof DashboardRoute
  '/drills': typeof DrillsRoute
  '/fresh-matches': typeof FreshMatchesRoute
  '/friends': typeof FriendsRoute
  '/highlights': typeof HighlightsRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/style': typeof StyleRoute
  '/terms': typeof TermsRoute
  '/matches/$matchId': typeof MatchesMatchIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/builds': typeof BuildsRoute
  '/dashboard': typeof DashboardRoute
  '/drills': typeof DrillsRoute
  '/fresh-matches': typeof FreshMatchesRoute
  '/friends': typeof FriendsRoute
  '/highlights': typeof HighlightsRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/style': typeof StyleRoute
  '/terms': typeof TermsRoute
  '/matches/$matchId': typeof MatchesMatchIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/builds': typeof BuildsRoute
  '/dashboard': typeof DashboardRoute
  '/drills': typeof DrillsRoute
  '/fresh-matches': typeof FreshMatchesRoute
  '/friends': typeof FriendsRoute
  '/highlights': typeof HighlightsRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/style': typeof StyleRoute
  '/terms': typeof TermsRoute
  '/matches/$matchId': typeof MatchesMatchIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/builds'
    | '/dashboard'
    | '/drills'
    | '/fresh-matches'
    | '/friends'
    | '/highlights'
    | '/login'
    | '/pricing'
    | '/privacy'
    | '/profile'
    | '/style'
    | '/terms'
    | '/matches/$matchId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/builds'
    | '/dashboard'
    | '/drills'
    | '/fresh-matches'
    | '/friends'
    | '/highlights'
    | '/login'
    | '/pricing'
    | '/privacy'
    | '/profile'
    | '/style'
    | '/terms'
    | '/matches/$matchId'
  id:
    | '__root__'
    | '/'
    | '/builds'
    | '/dashboard'
    | '/drills'
    | '/fresh-matches'
    | '/friends'
    | '/highlights'
    | '/login'
    | '/pricing'
    | '/privacy'
    | '/profile'
    | '/style'
    | '/terms'
    | '/matches/$matchId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BuildsRoute: typeof BuildsRoute
  DashboardRoute: typeof DashboardRoute
  DrillsRoute: typeof DrillsRoute
  FreshMatchesRoute: typeof FreshMatchesRoute
  FriendsRoute: typeof FriendsRoute
  HighlightsRoute: typeof HighlightsRoute
  LoginRoute: typeof LoginRoute
  PricingRoute: typeof PricingRoute
  PrivacyRoute: typeof PrivacyRoute
  ProfileRoute: typeof ProfileRoute
  StyleRoute: typeof StyleRoute
  TermsRoute: typeof TermsRoute
  MatchesMatchIdRoute: typeof MatchesMatchIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/builds': {
      id: '/builds'
      path: '/builds'
      fullPath: '/builds'
      preLoaderRoute: typeof BuildsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/drills': {
      id: '/drills'
      path: '/drills'
      fullPath: '/drills'
      preLoaderRoute: typeof DrillsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fresh-matches': {
      id: '/fresh-matches'
      path: '/fresh-matches'
      fullPath: '/fresh-matches'
      preLoaderRoute: typeof FreshMatchesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/friends': {
      id: '/friends'
      path: '/friends'
      fullPath: '/friends'
      preLoaderRoute: typeof FriendsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/highlights': {
      id: '/highlights'
      path: '/highlights'
      fullPath: '/highlights'
      preLoaderRoute: typeof HighlightsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/style': {
      id: '/style'
      path: '/style'
      fullPath: '/style'
      preLoaderRoute: typeof StyleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/matches/$matchId': {
      id: '/matches/$matchId'
      path: '/matches/$matchId'
      fullPath: '/matches/$matchId'
      preLoaderRoute: typeof MatchesMatchIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BuildsRoute: BuildsRoute,
  DashboardRoute: DashboardRoute,
  DrillsRoute: DrillsRoute,
  FreshMatchesRoute: FreshMatchesRoute,
  FriendsRoute: FriendsRoute,
  HighlightsRoute: HighlightsRoute,
  LoginRoute: LoginRoute,
  PricingRoute: PricingRoute,
  PrivacyRoute: PrivacyRoute,
  ProfileRoute: ProfileRoute,
  StyleRoute: StyleRoute,
  TermsRoute: TermsRoute,
  MatchesMatchIdRoute: MatchesMatchIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
